import * as React from 'react';

import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';

type ShoppingCartContextType = {
  cart?: CartsV2;
  isValidCart?: boolean;
  loading?: boolean;
};

const ShoppingCartContext = React.createContext<ShoppingCartContextType | undefined>(undefined);

export const useShoppingCart = () => {
  const context = React.useContext(ShoppingCartContext);

  return context;
};

export default ShoppingCartContext;
